<template>
  <v-menu
    v-model="dateMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
    v-bind="$attrs"
    :key="modelDateMenuKey"
  >
    <template v-slot:activator="{ on }">
      <MaskedTextField
        :inputData.sync="maskedModelDate"
        :mask-type="pickerType == 'date' ? 'date_range' : 'month_range'"
        :label="label"
        v-bind="$attrs"
        @update:inputData="setModelDate"
        @blur="lostFocus"
        :error-messages="invalidDateError"
      >
        <template slot="prependMask">
          <v-icon v-on="on">mdi-calendar</v-icon>
        </template>

        <template v-if="hasTodayButton" slot="appendMask">
          <v-icon @click="setToday">mdi-bookmark</v-icon>
        </template>
      </MaskedTextField>

      <!-- <v-text-field
        :value="modelDate | formatDate"
        :label="label"

        v-bind="$attrs"
      >
        <template v-slot:prepend>
          <v-icon v-on="on">mdi-calendar</v-icon>
        </template>
      </v-text-field> -->
    </template>
    <v-date-picker
      v-model="modelDate"
      @change="change"
      locale="pt-br"
      :type="pickerType"
      range
    />
  </v-menu>
</template>

<script>
import moment from "moment";
import MaskedTextField from "@shared_components/masked_text_field.vue"

 export default {
  data () {
   return {
     dateMenu: false,
     modelDate: [],
     maskedModelDate: [],
     modelDateMenuKey: 1,
     invalidDateError: null
   }
  },
  components: {
    MaskedTextField: MaskedTextField,
  },
  props: {
    inputData: {
      type: Array,
      default: null
    },
    label: {
      type: String,
      default: "Data"
    },
    pickerType: {
      type: String,
      default: "date"
    },
    hasTodayDate: {
      type: Boolean,
      default: false
    },
    hasTodayButton: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.hasTodayDate && !this.inputData) {
      this.setToday();
    } else {
      this.modelDate = this.inputData;
    }
    this.setMaskedModelDate();
  },
  methods: {
    change: function () {
      // console.log("changed", this.modelDate); 
      this.dateMenu = false;
      this.modelDateMenuKey++;
      this.setMaskedModelDate();
      this.emitDateChange();
    },
    setMaskedModelDate: function() {
      // console.log("this.modelDate", this.modelDate);
      if (this.pickerType == "month") {
        this.maskedModelDate = moment(this.modelDate[0]).format("MM/YYYY") + " ~ " + moment(this.modelDate[1]).format("MM/YYYY");
      } else {
        this.maskedModelDate = moment(this.modelDate[0]).format("DD/MM/YYYY") + " ~ " + moment(this.modelDate[1]).format("DD/MM/YYYY");
      }
      // console.log("this.maskedModelDate", this.maskedModelDate);
    },
    setModelDate: function() {
      // console.log("this.maskedModelDate", this.maskedModelDate);
      if (this.pickerType == "month" && this.maskedModelDate.length == 12) {
        this.modelDate = [moment(this.maskedModelDate.substring(0, 6), "MMYYYY").format("YYYY-MM"), moment(this.maskedModelDate.substring(6, 12), "MMYYYY").format("YYYY-MM")];
        this.emitDateChange();
      } else if (this.pickerType == "date" && this.maskedModelDate.length == 16) {
        this.invalidDateError = null;
        if (!moment(this.maskedModelDate.substring(0, 8), "DDMMYYYY").isValid() && !moment(this.maskedModelDate.substring(8, 16), "DDMMYYYY").isValid()) {
          this.invalidDateError = "Data de Início e de Fim estão inválidas";
        } else if (!moment(this.maskedModelDate.substring(0, 8), "DDMMYYYY").isValid()) {
          this.invalidDateError = "Data de Início está inválida";
        } else if (!moment(this.maskedModelDate.substring(8, 16), "DDMMYYYY").isValid()) {
          this.invalidDateError = "Data de Fim está inválida";
        } else if (moment(this.maskedModelDate.substring(0, 8), "DDMMYYYY").isAfter(moment(this.maskedModelDate.substring(8, 16), "DDMMYYYY"))) {
          this.invalidDateError = "Data de Início é maior do que a Data de Fim";
        }
        if (!this.invalidDateError) {
          this.modelDate = [moment(this.maskedModelDate.substring(0, 8), "DDMMYYYY").format("YYYY-MM-DD"), moment(this.maskedModelDate.substring(8, 16), "DDMMYYYY").format("YYYY-MM-DD")];
          this.emitDateChange();
        }
      }
    },
    emitDateChange: function() {
      this.$emit('update:inputData', this.modelDate);
    },
    lostFocus: function(){
      if (this.maskedModelDate.length < 8){
        this.maskedModelDate = "";
        this.modelDate = null;
        this.emitDateChange();
      }
    },
    setToday: function() {
      if (this.pickerType == "month") {
        this.modelDate = [moment().format('YYYY-MM'), moment().format('YYYY-MM')];
      } else if (this.pickerType == "date") {
        this.modelDate = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
      }
      
      this.change();
    }
  },
  // computed: {
  //   computedStartDateFormatted() {
  //     return this.startDate ? moment(this.startDate).format("DD/MM/YYYY") : "";
  //   },
  //   computedEndDateFormatted() {
  //     return this.endDate ? moment(this.endDate).format("DD/MM/YYYY") : "";
  //   }
  // }
 }
</script>

<style scoped>
</style>
